@if (this.contractBase$ | async; as contract) {
  <div
    class="tab-pane fade flex-even active show"
    id="sales"
    role="tabpanel"
    aria-labelledby="sales-tab"
    >
    <div class="d-flex flex-column h-100">
      <div class="row mt-2">
        <div class="col-12 col-md">
          <div class="form-group row">
            <label class="col-4 col-form-label-sm" translate
              >CONTRACT_LBL_MARKETING_CAMPAIGN</label
              >
              <div class="col">
                <span class="form-control-plaintext form-control-sm">
                  {{ contract.campaignName }}
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-4 col-form-label-sm" translate
                >CONTRACT_LBL_MARKETING_MEDIUM</label
                >
                <div class="col">
                  <span class="form-control-plaintext form-control-sm">
                    {{ contract.mediumName }}
                  </span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-4 col-form-label-sm" translate
                  >CONTRACT_LBL_MARKETING_SOURCE</label
                  >
                  <div class="col">
                    <span class="form-control-plaintext form-control-sm">
                      {{ contract.sourceName }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col">
                @if (contract.campaignId === ReferralCampaign) {
                  <div class="form-group row">
                    <label class="col-4 col-form-label-sm" translate
                      >CONTRACT_LBL_MARKETING_REFERRER</label
                      >
                      <div class="col-auto">
                        <span class="form-control-plaintext form-control-sm">
                          @if (!contract.contactReferrerId) {
                            {{ contract.contactReferrerName }}
                          } @else {
                            <app-link-to
                              [id]="contract.contactReferrerId.toString()"
                              [label]="contract.contactReferrerName"
                              [url]="'/Contacts/Contacts/Details/'"
                              />
                            }
                          </span>
                        </div>
                      </div>
                    }
                    <div class="form-group row">
                      <label
                        class="col-4 col-form-label-sm"
                        translate
                        >CONTRACT_LBL_MARKETING_CREATION_DATE</label
                        >
                        <div class="col-auto">
                          <span class="form-control-plaintext form-control-sm">
                            {{ contract.creationDate | toLocalTime : "dd/MM/yyyy HH:mm" }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
